export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7916.82028263.jpg";